import { COMPONENT_FACTORY_CONFIG_INPUT_COMPONENTS } from '@core/components/component-factory/component-factory-config-input.registry';
import type { ConfigComponentContract } from '@shared/utils/content-builder/config-component-contract';
import { computedResolvedConfig } from '@shared/utils/content-builder/block-config-computed-resolver';
import type { CartFunnelOnBehalfUserEmailItemBlockConfig } from '@front-platform/content-builder';
import { cartFunnelOnBehalfUserEmailItemBlockResolveConfig } from '@front-platform/content-builder';
import { take } from 'rxjs/operators';
import { Component, OnInit, input } from '@angular/core';

import { DoodCartFunnelValueTarget } from '@store/cart-funnel/cart-funnel.model';
import { CartFunnelStoreSelector } from '@common/selectors/cart-funnel.selector';
import { CartFunnelStoreDispatcher } from '@common/dispatchers/cart-funnel.dispatcher';
export interface CartFunnelOnBehalfUserEmailItemBlockRuntimeConfig {
  'block_id'?: string;
  'form_id'?: string;
}

export type CartFunnelOnBehalfUserEmailItemBlockConfigInput = Partial<
  Omit<
    CartFunnelOnBehalfUserEmailItemBlockConfig,
    keyof CartFunnelOnBehalfUserEmailItemBlockRuntimeConfig
  > &
    CartFunnelOnBehalfUserEmailItemBlockRuntimeConfig
>;
export type CartFunnelOnBehalfUserEmailItemBlockResolvedConfig = Omit<
  CartFunnelOnBehalfUserEmailItemBlockConfig,
  keyof CartFunnelOnBehalfUserEmailItemBlockRuntimeConfig
> &
  Partial<CartFunnelOnBehalfUserEmailItemBlockRuntimeConfig>;
export interface CartFunnelOnBehalfUserEmailItemBlockContract extends ConfigComponentContract<
  CartFunnelOnBehalfUserEmailItemBlockConfigInput,
  CartFunnelOnBehalfUserEmailItemBlockResolvedConfig
> {}

@Component({
  selector: 'app-cart-funnel-on-behalf-user-email-item-block',
  templateUrl: './cart-funnel-on-behalf-user-email-item-block.component.html',
  standalone: false,
})
export class CartFunnelOnBehalfUserEmailItemBlockComponent
  implements OnInit, CartFunnelOnBehalfUserEmailItemBlockContract
{
  readonly config = input<CartFunnelOnBehalfUserEmailItemBlockConfigInput>({});
  readonly resolvedConfig = computedResolvedConfig<
    CartFunnelOnBehalfUserEmailItemBlockConfig,
    CartFunnelOnBehalfUserEmailItemBlockRuntimeConfig
  >(cartFunnelOnBehalfUserEmailItemBlockResolveConfig, () => ({ config: this.config() }));
  get title(): string {
    return this.resolvedConfig()['title'] as unknown as string;
  }
  get placeholder(): string {
    return this.resolvedConfig()['placeholder'] as unknown as string;
  }
  get required(): boolean {
    return this.resolvedConfig()['required'] as unknown as boolean;
  }
  get blockId(): string {
    return this.resolvedConfig()['block_id'] as unknown as string;
  }
  get formId(): string {
    return this.resolvedConfig()['form_id'] as unknown as string;
  }

  value = '';

  constructor(
    private cartFunnelSelector: CartFunnelStoreSelector,
    private cartFunnelDispatcher: CartFunnelStoreDispatcher,
  ) {}

  ngOnInit(): void {
    this.cartFunnelDispatcher.addValue({
      id: this.blockId,
      title: this.title,
      displayTitle: true,
      formId: this.formId,
      required: this.required,
      target: DoodCartFunnelValueTarget.OnBehalfUserEmail,
    });

    this.cartFunnelSelector
      .selectValue(this.blockId)
      .pipe(take(1))
      .subscribe(form => {
        this.value = form?.value?.toString() ?? '';
      });
  }

  onValueChange(_value: string | boolean): void {
    this.cartFunnelDispatcher.updateValue({
      id: this.blockId,
      changes: {
        value: _value,
      },
    });
  }
}
COMPONENT_FACTORY_CONFIG_INPUT_COMPONENTS.set(CartFunnelOnBehalfUserEmailItemBlockComponent, {
  'keyAliases': {},
});
